module.exports = __webpack_public_path__ + "img/poster-showtime.a2dedc6f.png";